<template>
  <div :id="id" class="b:modal" ref="modal">
    <div class="b:modal-overlay" data-modal-close></div>

    <div class="b:modal-content" ref="content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, ref } from 'vue'

  const modal = ref(null)
  const content = ref(null)

  defineProps({
    isOpen: {
      type: Boolean,
      default: false,
    },

    id: {
      type: String,
    },

    maxWidth: {
      type: String,
      default: '400px',
    },
  })

  function open() {
    modal.value.style.display = 'block'

    setTimeout(() => {
      modal.value.classList.add('b:modal-open')
    })
  }

  function close() {
    modal.value.classList.remove('b:modal-open')

    setTimeout(() => {
      modal.value.style.display = 'none'
    }, 300)
  }

  onMounted(() => {
    document.addEventListener('click', e => {
      if (e.target.matches(`[data-modal-open="${modal.value.id}"]`)) {
        open()
      }

      if (e.target.matches(`[data-modal-close]`)) {
        close()
      }
    })
  })
</script>

<style lang="scss">
  .b\:modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    display: none;
    padding: 24px;
    z-index: 100;

    .b\:modal-overlay {
      will-change: opacity;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: auto;
      background-color: rgba(#000, 40%);
      backdrop-filter: blur(8px);
      transition: opacity 0.2s ease-in-out;
      opacity: 0;
    }

    .b\:modal-content {
      will-change: transform;
      min-width: 400px;
      max-width: v-bind(maxWidth);
      margin: 0 auto;
      transition: 0.25s ease-in-out;
      transform: translateY(40px);
      opacity: 0;
    }

    &.b\:modal-open {
      .b\:modal-overlay {
        opacity: 1;
      }

      .b\:modal-content {
        opacity: 1;
        transform: translateY(0px);
      }
    }
  }
</style>
